import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
export default (path => {
  const exoPrefix = '/exo';
  if (path.startsWith(exoPrefix) && getEnv() === ENVS.QA) {
    return path.replace(exoPrefix, '');
  }
  return path;
});
//# sourceMappingURL=removeExoPrefixIfNeeded.js.map